import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Services.css';
import { scrollToSection } from '../utils/scroll';

const services = [
  {
    id: 1,
    num: '01',
    title: 'CDFI Treasury Strategy',
    description: 'Working with CDFI CFOs to optimize balance sheet structure, diversify capital sources — CRA banks, bond markets, InspereX, impact notes, philanthropic capital — and strengthen overall financial positioning.',
    tags: ['Balance Sheet', 'Capital Diversification', 'Cost of Funds', 'CFO Advisory'],
    link: '/services/cdfi-treasury-strategy'
  },
  {
    id: 2,
    num: '02',
    title: 'Fund Structuring & Launch',
    description: 'Designing and launching on- and off-balance sheet pooled investment funds — from community thesis validation through capital raise, close, and deployment.',
    tags: ['Pooled Funds', 'Capital Stack Design', 'Investor Fundraising', 'Fund Management'],
    link: '/services/fund-structuring'
  },
  {
    id: 3,
    num: '03',
    title: 'AI & Lending Operations',
    description: 'Implementing AI into CDFI lending workflows, from financial spreading and credit memo drafting to covenant tracking and portfolio monitoring.',
    tags: ['Lending Automation', 'AI Governance', 'Process Design', 'Staff Training'],
    link: '/services/ai-automation'
  },
  {
    id: 4,
    num: '04',
    title: 'Underwriting & Lending Strategy',
    description: 'Advising on lending product design, underwriting policies, and equitable lending practices to help CDFIs deploy capital effectively.',
    tags: ['Product Design', 'Policy Development', 'Risk Frameworks', 'Equitable Lending'],
    link: '/services/underwriting-lending'
  },
  {
    id: 5,
    num: '05',
    title: 'NMTC Pipeline & Deployment',
    description: 'Helping CDEs with NMTC allocation build deal pipeline, structure QLICI transactions, and deploy capital into qualified community projects.',
    tags: ['Pipeline Development', 'Deal Structuring', 'QLICI Underwriting', 'Deployment Strategy'],
    link: '/services/nmtc-consulting'
  }
];

const Services = () => {
  const servicesRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          servicesRef.current.classList.add('in-view');
        } else {
          servicesRef.current.classList.remove('in-view');
        }
      },
      { threshold: 0.1 }
    );

    if (servicesRef.current) {
      observer.observe(servicesRef.current);
    }

    return () => {
      if (servicesRef.current) {
        observer.unobserve(servicesRef.current);
      }
    };
  }, []);

  const servicesStyle = {
    background: "linear-gradient(135deg, #E67E45 0%, #d16a33 100%)",
    position: "relative"
  };

  return (
    <section id="services" className="services" ref={servicesRef} style={servicesStyle}>
      <div className="services-container">
        <h2>Our Services</h2>
        <p className="services-intro">
          <strong>Strategic Advisory for Mission-Driven Lenders</strong>
          Helping CDFIs strengthen operations, unlock capital, and deepen community impact
        </p>

        <div className="services-stack">
          {services.map((service) => (
            <div key={service.id} className="service-row" onClick={() => service.link ? navigate(service.link) : scrollToSection('contact')}>
              <div className="service-num">{service.num}</div>
              <div className="service-middle">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <div className="service-tags">
                  {service.tags.map((tag) => (
                    <span key={tag} className="service-tag">{tag}</span>
                  ))}
                </div>
              </div>
              <div className="service-arrow" aria-label="Learn more">
                <span>&#8594;</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
